module.exports = __webpack_public_path__ + "img/detail_icon_photo82.8e15bd59.png";